import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { TESTIDS } from "@/lib/testids";

const QUICK_ACTIONS = [
  {
    to: "/admin/pilotage/missions",
    label: "+ Mission",
    title: "Créer une mission",
    testId: TESTIDS.pilotage.dashboard.quickActionCreateMission,
  },
  {
    to: "/admin/pilotage/collaborateurs",
    label: "Collaborateur",
    title: "Ajouter un collaborateur",
    testId: TESTIDS.pilotage.dashboard.quickActionAddCollaborator,
  },
  {
    to: "/admin/pilotage/charges-fixes",
    label: "Charge fixe",
    title: "Ajouter une charge fixe",
    testId: TESTIDS.pilotage.dashboard.quickActionAddFixedCost,
  },
  {
    to: "/admin/pilotage/objectifs",
    label: "Objectifs",
    title: "Ouvrir les objectifs",
    testId: TESTIDS.pilotage.dashboard.quickActionObjectives,
  },
];

const toSelectValue = (nextValue) =>
  typeof nextValue === "string" ? nextValue : nextValue?.target?.value;

export default function PilotagePageHeader({
  currentYear,
  objectives,
  activeObjectiveId,
  onActiveObjectiveChange,
  onYearChange,
}) {
  const objectiveOptions = Array.isArray(objectives) ? objectives : [];
  const hasObjectives = objectiveOptions.length > 0;
  const resolvedActiveObjectiveId =
    activeObjectiveId || objectiveOptions[0]?.id || "";

  return (
    <div
      className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-between gap-2 px-6 py-4"
      data-testid={TESTIDS.pilotage.dashboard.pageHeader}
    >
      <div>
        <h1 className="text-xl font-semibold text-white">Pilotage</h1>
        <p
          className="mt-1 text-xs text-slate-400"
          data-testid={TESTIDS.pilotage.dashboard.currentYearBadge}
        >
          Année en cours : {currentYear}
        </p>
      </div>

      <label className="flex flex-col gap-1 text-sm text-slate-300">
        <span className="font-semibold">Année du Pilotage</span>
        <select aria-label="Année du Pilotage" value={currentYear}
          onChange={event => onYearChange?.(Number(event.target.value))}
          className="h-11 rounded-lg border border-lenvia-blue/50 bg-slate-900 px-3 text-base text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-lenvia-blue">
          {[2026, 2027].map(year => <option key={year}>{year}</option>)}
        </select>
        <span className="text-xs text-slate-400">S’applique à tous les blocs de cette page.</span>
      </label>
      <div className="flex flex-wrap gap-2" data-testid={TESTIDS.pilotage.dashboard.quickActionsBar}>
        {hasObjectives ? (
          <label className="flex items-center gap-2 rounded-md border border-white/10 bg-slate-900/70 px-2 text-xs text-slate-300">
            <span>Objectif actif</span>
            <select
              value={resolvedActiveObjectiveId}
              onChange={(event) => onActiveObjectiveChange?.(toSelectValue(event))}
              className="h-9 rounded-md border border-white/10 bg-slate-800 px-3 text-sm text-slate-200 outline-none transition-colors focus:border-lenvia-blue/50 focus:ring-2 focus:ring-lenvia-blue/20"
              data-testid={TESTIDS.pilotage.dashboard.objectiveSelector}
            >
              {objectiveOptions.map((objective) => (
                <option key={objective.id} value={objective.id}>
                  {objective.name}
                </option>
              ))}
            </select>
          </label>
        ) : (
          <Button
            asChild
            variant="outline"
            size="sm"
            className="h-9 border-lenvia-blue/40 text-lenvia-blue hover:bg-lenvia-blue/10 hover:text-lenvia-blue"
          >
            <Link
              to={`/admin/pilotage/objectifs?year=${currentYear}`}
              title="Créer un objectif"
              data-testid={TESTIDS.pilotage.dashboard.objectiveEmptyCta}
            >
              Créer un objectif
            </Link>
          </Button>
        )}

        {QUICK_ACTIONS.map((action) => (
          <Button
            key={action.to}
            asChild
            variant="outline"
            size="sm"
            className="h-9 border-white/10 text-slate-200 hover:bg-white/5 hover:text-white"
          >
            <Link to={action.to} title={action.title} data-testid={action.testId}>
              {action.label}
            </Link>
          </Button>
        ))}
      </div>
    </div>
  );
}
